var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13215",
    "data-name": "Group 13215",
    transform: "translate(-178 -302)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(178 302)",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12686",
    "data-name": "Group 12686",
    transform: "translate(190.477 314.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44609",
    "data-name": "Path 44609",
    d: "M12.462,175.985H3.306A3.125,3.125,0,0,1,0,172.694q0-1.932,0-3.864a1.05,1.05,0,0,1,1.042-1.157,1.055,1.055,0,0,1,1.035,1.165c0,1.3,0,2.6,0,3.9a1.055,1.055,0,0,0,1.159,1.172q9.237,0,18.474,0a1.046,1.046,0,0,0,1.145-1.152c0-1.342,0-2.684,0-4.026a1.034,1.034,0,0,1,2.038-.27,1.575,1.575,0,0,1,.036.385c0,1.31.005,2.619,0,3.929a3.11,3.11,0,0,1-3.22,3.211q-4.627.006-9.253,0",
    transform: "translate(0 -153.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44610",
    "data-name": "Path 44610",
    d: "M77.775,3.215v.456q0,6.9,0,13.794a1.832,1.832,0,0,0,.056.511,1.017,1.017,0,0,0,1.1.72,1.051,1.051,0,0,0,.917-.949c.01-.118,0-.238,0-.357q0-6.881,0-13.762v-.4c.114.078.192.125.263.182q1.623,1.3,3.244,2.593a1.038,1.038,0,1,0,1.318-1.6Q82.111,2.345,79.535.293A1.035,1.035,0,0,0,78.09.3q-2.511,2-5.017,4.013a1.034,1.034,0,1,0,1.3,1.609c1.035-.818,2.064-1.644,3.1-2.467.083-.066.168-.128.309-.236",
    transform: "translate(-66.347 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconBlack);
export default __webpack_public_path__ + "static/media/upload_icon_black.b60350bd39dae0713a6e043dbd8f866e.svg";
export { ForwardRef as ReactComponent };